var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
import FileUploader from 'devextreme/ui/file_uploader';
import { msg, updateWhenLocaleChanges } from '@lit/localize';
import { FileHelper } from '../../helpers';
import { FileStorageService } from '../../services/fileStorage/FileStorageService';
let DinapsisUploader = class DinapsisUploader extends LitElement {
    constructor() {
        super();
        /**
         * Gets or sets the interval time in milliseconds of the refresh token. 4 min by default.
         */
        this.refreshTokenInterval = 4 * 60 * 1000;
        /**
         * Define icon of the upload button.
         */
        this.selectButtonIcon = undefined;
        /**
         * Define if a the upload button appearance is outlined.
         */
        this.outlined = false;
        /**
         * A property that is used to set the preview enabled or not
         * It will only be displayed if the number of files is 1
         */
        this.showPreview = false;
        /**
         * Define the max file size of uploaded file.
         */
        this.maxFileSize = 0;
        /**
         * Gets or sets the FileInfo
         */
        this.fileInfo = { entityName: '', entityId: '' };
        /**
        * Gets or sets the multiple files
        */
        this.isMultiple = false;
        /**
         * Number of rows to display in the list before applying a scroll
         */
        this.numberOfRowsFileList = -1;
        // FileService Url
        this.baseUrl = 'https://api-plataforma.dinapsis.es';
        // Specifies if an end user can remove a file from the selection and interrupt uploading.
        this.allowCanceling = true;
        /**
         * Private property to toggle the title
         */
        this.toggleTitle = true;
        /**
         * A private property that is used to show the preview file
         */
        this.filePreview = null;
        // Unique id
        this.uploaderId = `uploader-container-${uuidv4()}`;
        // Element FileUploader DevExtreme component
        this.fileUploaderElement = undefined;
        // Container where is rendered the component
        this.container = undefined;
        // OpenID token
        this.token = '';
        // All the files that we obtain from the Get of the FileService
        this.currentFiles = [];
        // Save the last file uploaded in the session
        this.lastFileUploaded = { id: '' };
        // The height in px of a list item
        this.heightFileItem = 47.5;
        // Is true if file is in uploading process
        this.isFileUploading = false;
        updateWhenLocaleChanges(this);
        this.selectButtonText = '';
        this.dragDropText = '';
        this.titleText = '';
        this.canToggleTextOnDrag = false;
    }
    createRenderRoot() {
        return this;
    }
    async firstUpdated() {
        this.ValidateDinapsisApiConfiguration();
        this.updateToken()
            .then(() => {
            this.processInitializeComponent();
        });
        setInterval(() => {
            this.refreshToken();
        }, this.refreshTokenInterval);
    }
    refreshToken() {
        this.updateToken();
    }
    async processInitializeComponent() {
        var _a, _b, _c, _d, _e;
        this.ValidateInputFile();
        this.container = document.getElementById(this.uploaderId);
        this.fileUploaderElement = new FileUploader(this.container, {
            labelText: this.dragDropText,
            allowCanceling: this.allowCanceling,
            maxFileSize: this.maxFileSize,
            allowedFileExtensions: (_a = this.fileExtensionsOptions) === null || _a === void 0 ? void 0 : _a.allowedFileExtensions,
            accept: (_b = this.fileExtensionsOptions) === null || _b === void 0 ? void 0 : _b.accept,
            multiple: this.isMultiple,
            showFileList: true,
            uploadUrl: `${this.baseUrl}/FileStorage/${this.clientId}`,
            uploadHeaders: {
                Authorization: `Bearer ${this.token}`,
            },
            name: 'File',
            uploadCustomData: {
                clientId: this.clientId,
                entityName: (_c = this.fileInfo) === null || _c === void 0 ? void 0 : _c.entityName,
                entityId: (_d = this.fileInfo) === null || _d === void 0 ? void 0 : _d.entityId,
                fileKey: uuidv4(),
            },
        });
        if (this.selectButtonText)
            this.fileUploaderElement.option('selectButtonText', this.selectButtonText);
        // Set select button style
        (_e = this.container.querySelector('.dx-button')) === null || _e === void 0 ? void 0 : _e.classList.add('dinapsis-button');
        // Binding events
        this.fileUploaderElement.on('uploaded', this.uploadSuccess.bind(this));
        this.fileUploaderElement.on('uploadError', this.uploadError.bind(this));
        this.fileUploaderElement.on('uploadStarted', this.uploadStarted.bind(this));
        this.fileUploaderElement.on('uploadAborted', this.uploadAborted.bind(this));
        this.fileUploaderElement.on('filesUploaded', this.filesUploaded.bind(this));
        // Drop zone events
        this.fileUploaderElement.on('dropZoneEnter', this.dropZoneEnter.bind(this));
        this.fileUploaderElement.on('dropZoneLeave', this.dropZoneLeave.bind(this));
        // Value changed
        this.fileUploaderElement.on('valueChanged', this.valueChanged.bind(this));
        this.calculateHeightFileList();
        this.addIconToSelectButton();
        this.addOutlineToSelectButton();
        // Get previous uploaded files
        await this.fillTableFiles();
    }
    /**
     * The function calculates and sets the maximum height
     * of the file list container based on the height
     * of each file item and the number of rows in the file list.
     */
    calculateHeightFileList() {
        if (this.numberOfRowsFileList === -1)
            return;
        if (!this.container)
            return;
        const filesContainer = this.container.querySelector('.dx-fileuploader-files-container');
        if (!filesContainer)
            return;
        filesContainer.style.maxHeight = `${this.heightFileItem * this.numberOfRowsFileList}px`;
    }
    /**
     * The function moves uploading items to the top of the file uploader list.
     * @param {ValueChangedEvent} e - The parameter "e" is of type ValueChangedEvent.
     */
    valueChanged(e) {
        const { element } = e;
        const listContainer = element.querySelector('.dx-fileuploader-files-container');
        const uploadingItems = Array.from(listContainer.querySelectorAll('.dx-fileuploader-file-container')).filter((container) => {
            const buttonInContainer = container.querySelector('.dx-fileuploader-button-container .dx-fileuploader-button');
            return buttonInContainer && !buttonInContainer.classList.contains('dx-state-invisible');
        });
        uploadingItems.forEach((item) => {
            listContainer.prepend(item);
        });
        this.dispatchEvent(new CustomEvent('value-changed', { detail: { e } }));
    }
    /**
     * The function fills a table with uploaded files and dispatches a custom event
     * called "finish-uploading".
     */
    async filesUploaded() {
        // Get all files uploaded
        await this.fillTableFiles();
        // Set the preview
        this.getPreviewUrl();
        // Emit finish event
        this.dispatchEvent(new CustomEvent('finish-uploading'));
    }
    /**
     * The function retrieves the preview URL for
     * the last file uploaded and saves it in the filePreview variable.
     * @returns the value of the `filePreview` property, which is either the file data object from
     * `fileData[0]` or `null` if `fileData` is empty.
     */
    getPreviewUrl() {
        const { id } = this.lastFileUploaded;
        const fileData = this.currentFiles.filter((i) => i.id === id);
        if (fileData.length === 0) {
            this.filePreview = null;
            return;
        }
        // Save fileData
        this.filePreview = { ...fileData[0] };
    }
    /**
     * The fillTableFiles function retrieves files from a file storage service based on certain input
     * parameters and emits the retrieved files.
     */
    async fillTableFiles() {
        this.currentFiles = await this.GetFiles();
        this.emitCurrentFiles();
    }
    /**
     * The function emits a custom event called 'current-files' with the current files as the event
     * detail.
     */
    emitCurrentFiles() {
        if (this.isFileUploading)
            return;
        this.dispatchEvent(new CustomEvent('current-files', { detail: { files: this.currentFiles } }));
    }
    // TODO: falta en la api de plataforma añadir el parámetro opcional en el get del fileKey
    /**
     * The function is a private asynchronous function that retrieves a list of files using a
     * file storage service and returns the files as an array of `DinapsisFile` objects.
     * @returns an array of DinapsisFile objects.
     */
    async GetFiles() {
        var _a, _b;
        let files = [];
        const fileService = new FileStorageService(this.baseUrl, this.token);
        const inputElement = {
            clientId: this.clientId,
            entityName: (_a = this.fileInfo) === null || _a === void 0 ? void 0 : _a.entityName,
            entityId: (_b = this.fileInfo) === null || _b === void 0 ? void 0 : _b.entityId,
        };
        const data = await fileService.getFiles(inputElement);
        if (data.length > 0)
            files = data;
        return files;
    }
    /**
     * The function deletes a file if the uploader is not set to allow multiple files.
     */
    async deleteFileWhenUploaderIsNotMultiple() {
        if (this.isMultiple)
            return;
        const files = await this.GetFiles();
        if (files.length <= 1)
            return;
        const fileService = new FileStorageService(this.baseUrl, this.token);
        for (let i = 0; i < files.length - 1; i += 1) {
            const fileToDelete = files[i].id;
            try {
                // eslint-disable-next-line no-await-in-loop
                await fileService.deleteFile(this.clientId, fileToDelete);
            }
            catch (error) {
                console.error(`Error deleting file: ${files[i]}`);
            }
        }
        this.fillTableFiles();
    }
    async updateToken() {
        var _a;
        const tokenResult = await this.authenticationService
            .GetServiceAccountToken(this.authenticationTokenData);
        if (tokenResult) {
            this.token = tokenResult;
            const uploadHeaders = {
                Authorization: `Bearer ${tokenResult}`,
            };
            (_a = this.fileUploaderElement) === null || _a === void 0 ? void 0 : _a.option('uploadHeaders', uploadHeaders);
        }
        this.fillTableFiles();
    }
    /**
     * The function validates the Dinapsis API configuration by checking if the token and clientId are
     * empty.
     */
    ValidateDinapsisApiConfiguration() {
        if (this.authenticationService === undefined)
            throw new Error('Invalid authentication service');
        if (this.clientId === undefined)
            throw new Error('Invalid clientId');
        if (this.baseUrl === '')
            throw new Error('Invalid baseUrl');
    }
    /**
     * The function `ValidateInputFile` checks if the `entityName` and `entityId` properties of
     * `fileInfo` are valid and throws an error if they are not.
     */
    ValidateInputFile() {
        var _a, _b;
        if (((_a = this.fileInfo) === null || _a === void 0 ? void 0 : _a.entityName) === '')
            throw new Error('Invalid entityName');
        if (((_b = this.fileInfo) === null || _b === void 0 ? void 0 : _b.entityId) === '')
            throw new Error('Invalid fileKey');
    }
    /**
     * The function toggles the `toggleTitle` property
     * to false if `canToggleTextOnDrag` is false.
     */
    dropZoneEnter() {
        if (!this.canToggleTextOnDrag)
            return;
        this.toggleTitle = false;
    }
    /**
     * The function toggles the `toggleTitle` property
     * to true if `canToggleTextOnDrag` is true.
     */
    dropZoneLeave() {
        if (!this.canToggleTextOnDrag)
            return;
        this.toggleTitle = true;
    }
    /**
     * The function dispatches a custom event called "upload-started" with the file
     * information as the event detail when the upload start.
     * @param {UploadStartedEvent} e - The parameter "e" is of type UploadStartedEvent.
     */
    uploadStarted(e) {
        this.isFileUploading = true;
        this.dispatchEvent(new CustomEvent('upload-started', { detail: { file: e.file } }));
    }
    /**
     * The function dispatches a custom event called "upload-aborted" with details about
     * the aborted upload.
     * @param {UploadAbortedEvent} e - The parameter "e" is of type UploadAbortedEvent.
     */
    uploadAborted(e) {
        this.isFileUploading = false;
        this.dispatchEvent(new CustomEvent('upload-aborted', { detail: { file: e.file, message: e.message } }));
    }
    /**
     * The function handles the success event after a file has been uploaded, parsing
     * the response and dispatching a custom event with the file details.
     * @param {UploadedEvent} e - UploadedEvent - An event object that contains information about the
     * uploaded file.
     */
    uploadSuccess(e) {
        const { response } = e.request;
        const JSONResponse = JSON.parse(response);
        this.lastFileUploaded = JSONResponse;
        this.deleteFileWhenUploaderIsNotMultiple();
        this.isFileUploading = false;
        this.dispatchEvent(new CustomEvent('upload-success', { detail: { file: e.file, id: JSONResponse.id, message: e.message } }));
    }
    /**
     * The function dispatches a custom event with details about the upload error.
     * @param {UploadErrorEvent} e - The parameter "e" is of type UploadErrorEvent.
     * It is an event object that contains information about an upload error.
     */
    uploadError(e) {
        this.isFileUploading = false;
        this.dispatchEvent(new CustomEvent('upload-error', { detail: { file: e.file, message: e.message, error: e.error } }));
    }
    /**
     * The function adds an icon to a select button if it exists.
     */
    addIconToSelectButton() {
        var _a;
        if (!this.selectButtonIcon)
            return;
        const buttonContentEl = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.dx-button-content .dx-button-text');
        buttonContentEl === null || buttonContentEl === void 0 ? void 0 : buttonContentEl.insertAdjacentHTML('beforebegin', `<span class="material-icons-round button-icon">${this.selectButtonIcon}</span>`);
    }
    /**
     * The function adds an "outlined" class to the button
     * content element if the "outlined" property is true.
     */
    addOutlineToSelectButton() {
        var _a;
        if (!this.outlined)
            return;
        const buttonContentEl = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.dx-button');
        buttonContentEl === null || buttonContentEl === void 0 ? void 0 : buttonContentEl.classList.add('outlined');
    }
    /**
     * The function creates a preview of a file if the
     * showPreview flag is true and the isMultiple flag is false.
     * @returns an HTML template literal.
     */
    createPreview() {
        if (!this.showPreview || this.isMultiple)
            return html ``;
        return html `
      <dinapsis-preview-uploader .filePreview="${this.filePreview}"></dinapsis-preview-uploader>
    `;
    }
    /**
     * The function displays a list of allowed file extensions in an HTML format.
     * @returns an HTML template that displays a list of allowed file extensions.
     * If neither property is defined an empty string will be returned
     */
    showAllowedExtensions() {
        var _a, _b;
        if ((_a = this.fileExtensionsOptions) === null || _a === void 0 ? void 0 : _a.allowedFileExtensions) {
            return html `
        <div>
        ${msg('fileuploader.allowed_extensions')}:
            <span class="extensions">
              ${(_b = this.fileExtensionsOptions.allowedFileExtensionsMessage) !== null && _b !== void 0 ? _b : this.fileExtensionsOptions.allowedFileExtensions.join(', ')}
            </span>
        </div>
      `;
        }
        return '';
    }
    /**
     * The function displays the maximum file size in a human-readable format if it is
     * greater than 0.
     * @returns an HTML template string if the `maxFileSize`
     * is greater than 0. Otherwise, it returns an empty string.
     */
    showMaxFileSize() {
        if (this.maxFileSize > 0) {
            return html `
        <div>
          ${msg('fileuploader.max_size')}:
            <span class="size">
              ${FileHelper.humanFileSize(this.maxFileSize)}.
            </span>
        </div>
      `;
        }
        return '';
    }
    /**
     * The function creates a title container element
     * with the text specified in the `titleText` property
     * if the `toggleTitle` property is true.
     * @returns an HTML element wrapped in a div
     * with the class "title-container". The content of the div
     * is the value of the variable `this.titleText`.
     */
    createTitle() {
        if (!this.toggleTitle)
            return html ``;
        return html `<div class="title-container">${this.titleText}</div>`;
    }
    /**
     * The function returns a string of HTML that contains a div that contains the component.
     * @returns The return statement is returning the html template literal
     */
    render() {
        return html `
    <div class="dinapsis-uploader">
      ${this.createPreview()}
      ${this.createTitle()}
      <div class="dinapsis-uploader-component" id="${this.uploaderId}"></div>
      <div class="restrictions">
        ${this.showAllowedExtensions()}
        ${this.showMaxFileSize()}
      </div>
    </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], DinapsisUploader.prototype, "authenticationService", void 0);
__decorate([
    property({ type: Object })
], DinapsisUploader.prototype, "tokenEndpointUrl", void 0);
__decorate([
    property({ type: Number })
], DinapsisUploader.prototype, "refreshTokenInterval", void 0);
__decorate([
    property({ type: Object })
], DinapsisUploader.prototype, "authenticationTokenData", void 0);
__decorate([
    property({ type: String })
], DinapsisUploader.prototype, "clientId", void 0);
__decorate([
    property({ type: String })
], DinapsisUploader.prototype, "selectButtonText", void 0);
__decorate([
    property({ type: String })
], DinapsisUploader.prototype, "selectButtonIcon", void 0);
__decorate([
    property({ type: String })
], DinapsisUploader.prototype, "dragDropText", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisUploader.prototype, "outlined", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisUploader.prototype, "showPreview", void 0);
__decorate([
    property({ type: Number })
], DinapsisUploader.prototype, "maxFileSize", void 0);
__decorate([
    property({ type: Object })
], DinapsisUploader.prototype, "fileExtensionsOptions", void 0);
__decorate([
    property({ type: String })
], DinapsisUploader.prototype, "titleText", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisUploader.prototype, "canToggleTextOnDrag", void 0);
__decorate([
    property({ type: Object })
], DinapsisUploader.prototype, "fileInfo", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisUploader.prototype, "isMultiple", void 0);
__decorate([
    property({ type: Number })
], DinapsisUploader.prototype, "numberOfRowsFileList", void 0);
__decorate([
    property({ type: String })
], DinapsisUploader.prototype, "baseUrl", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisUploader.prototype, "allowCanceling", void 0);
__decorate([
    state()
], DinapsisUploader.prototype, "toggleTitle", void 0);
__decorate([
    state()
], DinapsisUploader.prototype, "filePreview", void 0);
DinapsisUploader = __decorate([
    customElement('dinapsis-uploader')
], DinapsisUploader);
export { DinapsisUploader };
//# sourceMappingURL=dinapsis-uploader.js.map